import { useEffect, useState } from "react";
import { cn } from "ui";

import { thumbnailGetterFactory } from "./thumbnailGetterFactory";

export interface VideoThumbnailProps {
  videoURL: string;
  className?: string;
  placeholder?: React.ReactNode;
}

export function VideoThumbnail(props: VideoThumbnailProps) {
  const [imgSrc, setImgSrc] = useState("");

  useEffect(() => {
    thumbnailGetterFactory(props.videoURL)
      .fetchImgSrc()
      .then((src) => {
        setImgSrc(src);
      });
  }, [props.videoURL]);

  if (!imgSrc) {
    if (props.placeholder) {
      return props.placeholder;
    }

    return null;
  }

  return (
    <img
      className={cn("shadow-md rounded-[4px]", props.className)}
      src={imgSrc}
    />
  );
}
